import { render, staticRenderFns } from "./CustomsPackingInfoInTable.vue?vue&type=template&id=ab6fbdc4"
import script from "./CustomsPackingInfoInTable.vue?vue&type=script&lang=ts"
export * from "./CustomsPackingInfoInTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomsPackingInfoInTable.vue?vue&type=style&index=0&id=ab6fbdc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports